import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { StorageService } from 'app/core/services/storage/storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthorizationGuard implements CanActivate {
  public constructor(
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map((authResult) => authResult.isAuthenticated),
    );
  }
}
